import { MonoSpan } from 'dashboard/components/Typography';
import Sticker from 'design-system/components/Sticker';

interface EventNameStickerProps {
  eventName: string;
}

const EventNameSticker = ({ eventName }: EventNameStickerProps) => {
  return (
    <Sticker>
      <MonoSpan>{eventName}</MonoSpan>
    </Sticker>
  );
};

export default EventNameSticker;
